<template>
  <BaseModal
    ref="baseModalRef"
    :title="'Imágenes'"
    modal-id="images"
    :isVisible="true"
    @close="closeDialog"
    @minimize="$emit('minimize', 'images')"
    @restore="$emit('restore', 'images')"
  >
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="row h-100">
          <div class="h-70 media-container media-container-small">
            <div ref="imageContainer" class="image-container">
              <img
                v-if="selectedPhoto?.filename_jpg"
                :src="
                  '/fserver/videos' +
                    selectedPhoto?.filename_jpg?.replace('Stills', 'stills').replace('\\', '/') ||
                  ''
                "
                alt="Foto"
                width="auto"
                class="video-player"
              />
            </div>
          </div>
          <div class="row">
            <div class="justify-content-center mb-1">
              <button @click="toggleFullScreen" class="btn btn-secondary btn-sm d-block">
                Ampliar a Pantalla Completa
              </button>
            </div>
          </div>
          <div class="row h-30">
            <div class="col-2 col-2-small filters-small">
              <h5>Filtros</h5>
              <div class="row">
                <div class="filters-col-small">
                  <select
                    class="form-select form-select-sm mb-1"
                    v-model="filters.data"
                    aria-label=""
                    @change="callApi"
                  >
                    <option selected value="">Video</option>
                    <option value="PRIMARY">Primary</option>
                    <option value="ALTERNATE">Alternate</option>
                  </select>

                  <div class="filter-group">
                    <!-- FECHA DESDE -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showStartDate"
                        v-model="filters.showStartDate"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Desde </label>
                    </div>
                    <div v-if="filters.showStartDate">
                      <input
                        type="date"
                        v-model="filters.start_date"
                        @change="callApi"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- FECHA HASTA -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showEndDate"
                        v-model="filters.showEndDate"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
                    </div>
                    <div v-if="filters.showEndDate">
                      <input
                        type="date"
                        v-model="filters.end_date"
                        @change="callApi"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- TIPO -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="type"
                        v-model="filters.showTipo"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Tipo </label>
                    </div>
                    <div :hidden="!filters.showTipo">
                      <select v-model="filters.tipo" @change="callApi" class="form-control">
                        <option class="form-select form-select-sm" value="HD-EO">HD-EO</option>
                        <option class="form-select form-select-sm" value="MWIR">MWIR</option>
                      </select>
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- ZONA -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showZona"
                        v-model="filters.showZona"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Zona </label>
                    </div>
                    <div :hidden="!filters.showZona" class="form-text">
                      <label class="form-text-label" for="flexTextDefault"> Lat </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="init_number"
                        v-model="filters.lat_zona"
                        @change="callApi"
                      />
                      <label class="form-text-label" for="flexTextDefault"> Lon </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="end_number"
                        v-model="filters.lon_zona"
                        @change="callApi"
                      />

                      <label class="form-text-label" for="flexTextDefault"> Radio </label>
                      <input
                        class="form-number-input"
                        type="number"
                        id="end_number"
                        v-model="filters.rad_zona"
                        @change="callApi"
                      />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- PREDIO -->
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="showPredios"
                        v-model="filters.showPredio"
                        @change="callApi"
                      />
                      <label class="form-check-label" for="flexCheckDefault"> Predio </label>
                    </div>
                    <div :hidden="!filters.showPredio" v-if="prediosList">
                      <select
                        class="form-select form-select-sm"
                        aria-label="Default select example"
                        v-model="filters.predio_name"
                        @change="callApi"
                      >
                        <option v-for="predio in prediosList" v-bind:key="predio.name">
                          {{ predio.name }}
                        </option>
                      </select>
                      <label class="form-text-label" for="flexTextDefault"> Radio </label>
                      <input
                        class="form-number-input"
                        type="number"
                        v-model="filters.predio_rad"
                        @change="callApi"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-5 col-5-small">
              <div class="text-center">
                <label
                  >Imagenes Filtradas <span>({{ cantidadPhotos }})</span></label
                >
              </div>

              <!-- Lista responsive de imágenes -->
              <div class="images-list-container">
                <div
                  v-for="photo in photoFiles"
                  :key="photo.photo_id"
                  class="image-item"
                  :class="{ selected: selectedPhoto?.photo_id === photo.photo_id }"
                  @click="changePhoto(photo)"
                >
                  <div class="image-item-content">
                    <!-- Nombre del archivo (mismo que mostraba el select) -->
                    <div class="image-filename">
                      {{ getImageFilename(photo.filename_jpg) }}
                    </div>
                  </div>
                </div>

                <!-- Mensaje cuando no hay imágenes -->
                <div v-if="photoFiles.length === 0" class="no-images">
                  <i class="bi bi-image"></i>
                  <p>No se encontraron imágenes</p>
                </div>
              </div>
            </div>

            <div class="datos-media datos-media-small">
              <div class="row">
                <div class="col-3">
                  <label>Archivo</label>
                </div>
                <div class="col-9">
                  <label>{{ getFilenameFromPath(photoDetail?.filename_jpg) }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>UTC</label>
                </div>
                <div class="col-9">
                  <label>{{ photoDetail?.utc }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Tipo</label>
                </div>
                <div class="col-9">
                  <label>{{ getFileSigla(photoDetail?.filename_jpg) }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Vértices</label>
                </div>
                <div class="col-9">
                  <label> {{ getGeoJsonCoordinates(photoDetail?.cam_polygon) }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <label>Centro Imagen</label>
                </div>
                <div class="col-9">
                  <label>{{ getGeoJsonCoordinates(photoDetail?.center_location) }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { ref, defineEmits, onMounted, reactive } from 'vue'
import BaseModal from './base/BaseModal.vue'
import type { PhotoFile, PhotoFilesFilter, PhotoDetailResponse, PhotoDetailEntry } from '../types'
import { useServicesStore } from '@/stores/services'
import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'
import API from '@/services'

const global = useGlobalStore()
const { loadedPhotos, selectedPhoto } = storeToRefs(global)

const serv = useServicesStore()
const { prediosList, events, photoFiles, cantidadPhotos } = storeToRefs(serv)

const imageContainer = ref<HTMLElement | null>(null)

const filters = reactive({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: '',
  data: '',
  showTipo: false,
  tipo: '',
  inicio_objetivo: 0,
  final_objetivo: 0,
  showZona: false,
  lat_zona: 0,
  lon_zona: 0,
  rad_zona: 10,
  showPredio: false,
  predio_name: '',
  predio_rad: 10,
  showEvent: false,
  event: 0,
  oscuras: false
})

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'imageSelected', coordenadas: number[]): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
}>()

const baseModalRef = ref()
const photoDetail = ref<PhotoDetailEntry | null>(null)

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  }
})

// Función para obtener solo el nombre del archivo
function getFilenameFromPath(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null
  const parts = fullPath.split('\\')
  const filename = parts[parts.length - 1] || ''
  return filename.trim() === '' ? null : filename
}

// Función para extraer la sigla (texto entre el último "_" y la extensión)
function getFileSigla(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null

  const filename = getFilenameFromPath(fullPath)
  if (!filename) return null

  // Ejemplo: "2024-02-28_21-16-33-827_HD-EO.jpg"

  // Separar por puntos para quitar la extensión
  const nameWithoutExtension = filename.split('.')[0]
  if (!nameWithoutExtension) return null

  // Separar por "_" y tomar el último elemento
  const parts = nameWithoutExtension.split('_')
  const sigla = parts[parts.length - 1] || ''
  return sigla.trim() === '' ? null : sigla
}

// Función para obtener el nombre completo sin la ruta
function getFullFilename(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null
  const parts = fullPath.split('\\')
  const filename = parts[parts.length - 1] || ''
  return filename.trim() === '' ? null : filename
}

// Función combinada que retorna tanto el filename como la sigla
function parseFilename(fullPath: string | null | undefined): {
  filename: string | null
  sigla: string | null
  fullFilename: string | null
} {
  if (!fullPath || fullPath.trim() === '') {
    return { filename: null, sigla: null, fullFilename: null }
  }

  const fullFilename = getFilenameFromPath(fullPath)
  if (!fullFilename) {
    return { filename: null, sigla: null, fullFilename: null }
  }

  const nameWithoutExtension = fullFilename.split('.')[0]
  if (!nameWithoutExtension) {
    return { filename: null, sigla: null, fullFilename: fullFilename }
  }

  const parts = nameWithoutExtension.split('_')
  const sigla = parts[parts.length - 1] || ''

  return {
    filename: nameWithoutExtension.trim() === '' ? null : nameWithoutExtension,
    sigla: sigla.trim() === '' ? null : sigla,
    fullFilename: fullFilename
  }
}

// También actualiza getImageFilename para consistencia
function getImageFilename(filename: string | null | undefined): string | null {
  if (!filename || filename.trim() === '') return null

  // Mismo comportamiento que el select: photo.filename_jpg.split('\\')[3]
  const parts = filename.split('\\')
  const result = parts[3] || parts[parts.length - 1] || ''
  return result.trim() === '' ? null : result
}
function getGeoJsonCoordinates(geoJson: string | null | undefined): string {
  if (!geoJson) return 'N/A'

  try {
    const location = JSON.parse(geoJson)

    if (location.type === 'Point' && location.coordinates && Array.isArray(location.coordinates)) {
      // Para Point: retorna "lat lon"
      const [longitude, latitude] = location.coordinates
      return `${latitude} ${longitude}`
    }

    if (
      location.type === 'Polygon' &&
      location.coordinates &&
      Array.isArray(location.coordinates)
    ) {
      // Para Polygon: retorna "lat1 lon1,lat2 lon2,lat3 lon3,..."
      const coordinates = location.coordinates[0] // Primer anillo del polígono

      if (Array.isArray(coordinates)) {
        const formattedCoords = coordinates
          .map(([lon, lat]: [number, number]) => `${lat} ${lon}`)
          .join(', ')

        return formattedCoords
      }
    }

    return 'Formato no válido'
  } catch (error) {
    console.error('Error parseando coordenadas:', error)
    return 'Error parseando'
  }
}
async function fetchPhotoDetail(photoId: number) {
  try {
    console.log('🔍 Obteniendo detalles de la foto ID:', photoId)

    const { status, data } = await API.getPhotoDetail(photoId)

    if (status === 200 && data.Entries.Entry.length > 0) {
      photoDetail.value = data.Entries.Entry[0]
      console.log('✅ Detalles obtenidos:', photoDetail.value)

      // Opcional: parsear las ubicaciones JSON
      if (photoDetail.value) {
        const parsedLocations = parsePhotoLocations(photoDetail.value)
        console.log('📍 Ubicaciones parseadas:', parsedLocations)
      }

      return photoDetail.value
    } else {
      console.error('❌ No se encontraron detalles para la foto')
      photoDetail.value = null
      return null
    }
  } catch (error) {
    console.error('❌ Error obteniendo detalles de la foto:', error)
    photoDetail.value = null
    return null
  }
}
// Función auxiliar para parsear las ubicaciones GeoJSON
function parsePhotoLocations(detail: PhotoDetailEntry) {
  try {
    return {
      camera: JSON.parse(detail.camera_location),
      center: JSON.parse(detail.center_location),
      min: JSON.parse(detail.min_location),
      max: JSON.parse(detail.max_location),
      polygon: JSON.parse(detail.cam_polygon)
    }
  } catch (error) {
    console.error('Error parseando ubicaciones:', error)
    return null
  }
}
function closeDialog() {
  emit('closed')
}
function changePhoto(photo: PhotoFile) {
  selectedPhoto.value = photo
  if (photo.photo_id) {
    fetchPhotoDetail(photo.photo_id)
  }
  emit('imageSelected', [
    Number(selectedPhoto.value?.lon || 0),
    Number(selectedPhoto.value?.lat || 0)
  ])
}
onMounted(() => {
  callApi()
})
async function callApi() {
  loadedPhotos.value = false
  const filtros: PhotoFilesFilter = {
    start_date: filters.showStartDate ? filters.start_date.replace(/-/g, '') : '',
    end_date: filters.showEndDate ? filters.end_date.replace(/-/g, '') : '',
    tipo: filters.showTipo ? filters.tipo : '',
    lat_zona: filters.showZona ? filters.lat_zona : 0,
    lon_zona: filters.showZona ? filters.lon_zona : 0,
    rad_zona: filters.showZona ? filters.rad_zona : 0,
    predio_name: filters.showPredio ? filters.predio_name : '',
    predio_rad: filters.showPredio ? filters.predio_rad : 0,
    event: filters.showEvent ? filters.event : 0,
    brightness: filters.oscuras ? 0 : 80
  }
  await serv.dispatchListPhotos(filtros)
  loadedPhotos.value = true
}
function toggleFullScreen() {
  if (!document.fullscreenElement) {
    imageContainer.value?.requestFullscreen().catch((err: Error) => {
      alert(`Error al intentar entrar en modo de pantalla completa: ${err.message} (${err.name})`)
    })
  } else {
    document.exitFullscreen()
  }
}
</script>

<style lang="css" scoped>
.images-title {
  font-weight: 600;
  color: white;
  font-size: 14px;
}

.count-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

/* .images-list-container {
  height: 100%;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
} */

.images-list-container::-webkit-scrollbar {
  width: 6px;
}

.images-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.images-list-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.image-item {
  margin-bottom: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
}

.image-item:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.image-item.selected {
  background: rgba(91, 161, 223, 0.3);
  border-color: #5ba1df;
  box-shadow: 0 2px 8px rgba(91, 161, 223, 0.3);
}

.image-item-content {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  position: relative;
}

.image-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.image-icon i {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
}

.image-filename {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: white;
  word-break: break-word;
  line-height: 1.3;
  min-width: 0;
}

.selection-indicator {
  color: #5ba1df;
  font-size: 16px;
  margin-left: 8px;
}

.no-images {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
}

.no-images i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
}

.no-images p {
  margin: 0;
  font-size: 14px;
}

span.closeCampos.close {
  height: 25px;
  line-height: 9px;
  background-color: #6c757d;
  padding: 6px;
  border-radius: 5px;
}

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.form-select {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
}

.col-10 {
  width: 82%;
  max-width: calc(100% - 135px);
}

.btn-secondary {
  justify-self: center;
  font-size: 12px;
  display: block;
  width: 80%;
}

.modal-container {
  min-width: 370px;
  width: 470px;
  height: 530px;
  min-height: 330px;
  max-height: 85vh;
}

.form,
.container-fluid,
.col-10 {
  height: 100%;
}

.row,
.col-10 {
  padding-right: 0%;
  justify-content: space-evenly;
}

h5 {
  height: max-content;
}

input,
.form-select label {
  max-width: 100%;
}

input.form-text-input,
input.form-number-input,
label.form-text-label {
  font-size: 12px;
}

.img-title {
  font-size: 14px;
  text-align: left;
  font-weight: normal;
}

.image-container {
  height: 100%;
  display: flex;
  justify-content: center;
}

.video-player {
  max-height: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9 !important;
}

@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }
}
</style>
